import type { RouteRecordRaw } from 'vue-router';

export const inboxRoutes: RouteRecordRaw[] = [
  {
    path: '/pages/inbox',
    name: 'InboxList',
    component: () => import('./views/InboxListPage.vue'),
    meta: {
      titleKey: 'common.inbox.listTitle',
      requiresAuth: true,
      layout: 'full',
      devOnly: true
    }
  }
];
